// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e68d584b","145":"b50bb1ab","218":"139f77ca","290":"86b35fbf","450":"58b5f2ec","540":"a5dc2ee0","559":"aa31df0a","565":"1b84441f","609":"09546108","720":"bd3090f4","771":"e4fb673d"}[chunkId] + ".chunk.js";
};